// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3O1Cw","large":"styles_large__feY74"};